// extracted by mini-css-extract-plugin
export default {"close-btn":"drawer-header_close-btn__S+R2Y","close-btn-icon":"drawer-header_close-btn-icon__7wghS"};